interface ToastProps {
  message: string;
}

export default function Toast({ message }: ToastProps) {
  if (!message) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed bottom-6 left-1/2 z-50 -translate-x-1/2">
      <div className="flex items-center gap-2 rounded-full border border-background-700/40 bg-foreground-950 px-4 py-2 text-xs text-background-50">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-information-line text-sm" />
        </span>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}